<template>
  <v-dialog
    v-model="dialog"
    width="600"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text">
        <span class="text-uppercase">Đổi Mật khẩu</span>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-form ref="form" flat class="pa-6">
        <div class="mb-4">Đổi mật khẩu:</div>
        <v-text-field
          v-model="password"
          label="Mật khẩu mới"
          required
          outlined
          dense
          :type="showPassword ? 'text' : 'password'"
          hint="ít nhất 6 ký tự"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
        ></v-text-field>
        <v-text-field
          v-model="confirmPassword"
          label="Xác nhận mật khẩu"
          required
          outlined
          dense
          :type="showPassword ? 'text' : 'password'"
          :rules="[rules.required, rules.min, rules.match]"
          hint="ít nhất 6 ký tự"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        ></v-text-field>
      </v-form>
      <v-card-actions class="pr-6 pb-6 mt-n8">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="px-4"
          color="primary"
          @click="save"
          :loading="loading"
          >Đổi Mật Khẩu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      password: '',
      confirmPassword: '',
      showPassword: false,
      rules: {
        required: value => !!value || 'Bắt buộc.',
        min: v => v.length >= 6 || 'ít nhất 6 ký tự',
        match: v => v === this.password || `Mật khẩu không trùng`
      }
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('rooms', ['createRoom']),
    ...mapActions('user', ['updateUser']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      await this.updateUser({
        id: this.user.id,
        password: this.password
      })
      this.loading = false
      this.$refs.form.reset()
      this.dialog = false
      this.$alert.success('Đổi Mật Khẩu Thành Công')
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
      console.log(state)
    }
  }
}
</script>
